import React from 'react'

const CONNECTOR_TABS = [
    { key: 'Details', label: 'Details' },
    { key: 'Mappings', label: 'Mappings' },
    { key: 'ManageEntities', label: 'Manage Entities' }
]

/**
 * Connector tabs. The highlight comes from the activeTab prop rather than a class
 * toggled on the DOM, so it cannot drift from what is actually rendered.
 */
const Tabs = ({ activeTab, getActiveTab }) => (
    <div className="tabMenuContainer">
        <ul className="nav">
            {CONNECTOR_TABS.map((tab) => (
                <li className="nav-item" key={tab.key}>
                    <a
                        className={`nav-link tabItem${tab.key === activeTab ? ' active' : ''}`}
                        onClick={() => getActiveTab(tab.key)}
                    >
                        {tab.label}
                    </a>
                </li>
            ))}
        </ul>
    </div>
)

export default Tabs
